// Title case for interface text. Source strings are written in sentence case;
// the casing preference decides how they display.

const minorWords = new Set([
  'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in', 'into', 'nor',
  'of', 'on', 'or', 'per', 'the', 'to', 'via', 'vs', 'with',
])

/**
 * Capitalizes the first letter of each major word and leaves the rest of the
 * word untouched, so acronyms and names keep their own capitals, and leaves
 * versions and numbers (v1.0, 508) as written. Minor words
 * stay lowercase except at the start of a sentence or after a colon.
 */
/** Names written in lowercase wherever they appear: commands and package names. */
const lowercaseNames = new Set(['npm', 'npx', 'missiondesign', 'llms'])

export function titleCase(text: string): string {
  let start = true
  return text.replace(/[\p{L}\p{N}][\p{L}\p{N}'’]*|[.:?!](?=\s|$)/gu, (word, offset: number) => {
    if (/^[.:?!]$/.test(word)) {
      start = true
      return word
    }
    // Part of a domain, path or compound (.gov, and/or, e-file) keeps its case.
    const joined = /[./@-]/.test(text[offset - 1] ?? '')
    const keep = joined || /\d/.test(word) || lowercaseNames.has(word) || (!start && minorWords.has(word.toLowerCase()))
    start = false
    return keep ? word : word.charAt(0).toUpperCase() + word.slice(1)
  })
}
